var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaystore = function SvgPlaystore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#playstore_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#32BBFF",
    d: "M17.923 8.232C15.135 6.672 10.661 4.17 3.72.282A1.67 1.67 0 0 0 2.248.09L14.157 12zM2.248.09Q2.117.134 1.995.2a1.68 1.68 0 0 0-.891 1.488v20.624a1.67 1.67 0 0 0 1.144 1.597l11.908-11.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32BBFF",
    d: "M14.157 11.999 2.248 23.908a1.66 1.66 0 0 0 1.472-.193c6.731-3.769 11.156-6.243 13.976-7.816l.231-.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C9FD9",
    d: "M1.104 11.999v10.312a1.67 1.67 0 0 0 1.144 1.597l11.908-11.909z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29CC5E",
    d: "M3.72.283A1.68 1.68 0 0 0 1.995.199l11.981 11.98 3.948-3.947C15.136 6.673 10.66 4.17 3.72.282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D93F21",
    d: "M13.976 11.818 1.996 23.8a1.67 1.67 0 0 0 1.724-.084c6.731-3.769 11.156-6.243 13.976-7.816l.231-.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    d: "M22.897 12a1.67 1.67 0 0 0-.86-1.469s-1.069-.596-4.345-2.428l-3.896 3.896 3.9 3.9c3.24-1.819 4.34-2.432 4.34-2.432.572-.32.86-.896.86-1.468"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA0",
    d: "M22.037 13.467c.571-.32.86-.897.86-1.468h-9.101l3.9 3.9c3.24-1.819 4.34-2.432 4.34-2.432"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "playstore_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPlaystore;